import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import StructuredData from "@/components/StructuredData";
import Breadcrumb from "@/components/Breadcrumb";
import GaragisteHero from "@/components/metiers/garagiste/GaragisteHero";
import GaragisteSolutions from "@/components/metiers/garagiste/GaragisteSolutions";
import GaragisteAdvantages from "@/components/metiers/garagiste/GaragisteAdvantages";
import GaragisteTestimonials from "@/components/metiers/garagiste/GaragisteTestimonials";
import GaragisteContact from "@/components/metiers/garagiste/GaragisteContact";
import { garagisteSchema } from "@/data/metiers/garagisteData";

const GaragisteDetail = () => {

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <SEO 
        title="Gestion déchets automobile - Solutions garagistes | Groupe Fabre Environnement"
        description="Solutions complètes pour garagistes : collecte huiles usagées, batteries, pneus, pièces métalliques. Conformité réglementaire, valorisation optimale. Devis gratuit."
        canonical="/nos-metiers/garagiste"
        keywords="gestion déchets automobile, collecte huiles usagées, recyclage batteries, pneus usagés, déchets garagiste, conformité ICPE, valorisation métaux auto"
      />
      
      <StructuredData data={garagisteSchema} />
      
      <Navbar />
      
      <main className="flex-grow pt-20">
        <GaragisteHero />
        
        {/* Breadcrumb */}
        <nav aria-label="Fil d'Ariane" className="bg-white py-4 border-b border-gray-100 shadow-sm">
          <div className="container mx-auto px-4">
            <Breadcrumb
              items={[
                { label: "Métiers", href: "/nos-metiers" },
                { label: "Garagiste", href: "/nos-metiers/garagiste", current: true }
              ]}
            />
          </div>
        </nav>

        <GaragisteSolutions />
        <GaragisteAdvantages />
        <GaragisteTestimonials />
        <GaragisteContact />
      </main>
      
      <Footer />
    </div>
  );
};

export default GaragisteDetail;